import { render, staticRenderFns } from "./StandardInputAuto.vue?vue&type=template&id=4b2d954c&scoped=true"
import script from "./StandardInputAuto.vue?vue&type=script&lang=js"
export * from "./StandardInputAuto.vue?vue&type=script&lang=js"
import style0 from "./StandardInputAuto.vue?vue&type=style&index=0&id=4b2d954c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2d954c",
  null
  
)

export default component.exports